// Due date filter display labels
export const DUE_DATE_LABELS = {
  TODAY: 'Due: Today',
  THIS_WEEK: 'Due: This Week',
  THIS_MONTH: 'Due: This Month',
  THIS_YEAR: 'Due: This Year',
  ALL_DATES: 'Due: All Dates',
};

// API values for due_date_range param
export const DUE_DATE_RANGE_VALUES = {
  TODAY: 'today',
  THIS_WEEK: 'this_week',
  THIS_MONTH: 'this_month',
  THIS_YEAR: 'this_year',
  ALL_DATES: 'all_dates',
};

// Map from display label → API value
export const DUE_DATE_RANGE_MAP = {
  [DUE_DATE_LABELS.TODAY]: DUE_DATE_RANGE_VALUES.TODAY,
  [DUE_DATE_LABELS.THIS_WEEK]: DUE_DATE_RANGE_VALUES.THIS_WEEK,
  [DUE_DATE_LABELS.THIS_MONTH]: DUE_DATE_RANGE_VALUES.THIS_MONTH,
  [DUE_DATE_LABELS.THIS_YEAR]: DUE_DATE_RANGE_VALUES.THIS_YEAR,
  [DUE_DATE_LABELS.ALL_DATES]: DUE_DATE_RANGE_VALUES.ALL_DATES,
};

export const DATE_FILTER_OPTIONS = Object.values(DUE_DATE_LABELS);

export const TASK_STATUS_OPTIONS = [
  { label: 'To Do', value: 'to_do' },
  { label: 'Completed', value: 'complete' },
  { label: 'Overdue', value: 'overdue' },
  { label: 'Archived', value: 'archived' },
];

// Map from API status value → display label
export const TASK_STATUS_LABELS = {
  to_do: 'To Do',
  overdue: 'Overdue',
  complete: 'Completed',
  archived: 'Archived',
};

// Page titles keyed by route segment
export const PAGE_TITLES = {
  ALL_TASKS: 'All Tasks',
  INBOUND_SCREENINGS: 'Inbound Screening Tasks',
  USER_CREATED: 'User-Created Tasks',
};

// Sentinel value sent to filter[assignee_employee_id] for tasks with no user assignee
export const UNASSIGNED_FILTER_VALUE = 'unassigned';

// Route segments
export const ROUTE_SEGMENTS = {
  ALL: '/all',
  INBOUND_SCREENINGS: '/inbound-screenings',
  USER_CREATED: '/user-created',
};
